/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/reducers/activeSectors.reducer.js
 * File: activeSectors.reducer.js
 * Created Date: Monday, February 25th 2019, 2:27:58 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Mar 06 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import * as Actions from '../actions'
import * as ProjectActions from 'client/app/sectors/ProjectList/store/actions'

const initialSectorState = {
  project: {
    config: null
  },
  document: null
}

export default activeSectors

function activeSectors (state = initialSectorState, action) {
  switch (action.type) {
    case Actions.SET_ACTIVE_PROJECT:
      return reduceActiveProject(state, action)
    case ProjectActions.GET_PROJECT_CONFIG_DATA_SUCCESS:
      return reduceActiveProjectConfig(state, action)

    case Actions.SET_ACTIVE_DOCUMENT:
      return reduceActiveDocument(state, action)

    default: return state
  }
}

function reduceActiveDocument (state, action = {}) {
  const newState = state
  newState.document = {
    id: action.data.id,
    index: action.data.index,
    token: action.data.token,
    name: action.data.name,
    starred: action.data.star,
    data: action.data.data
  }
  return Object.assign({}, state, newState)
}

function reduceActiveProject (state, action = {}) {
  const newState = state
  // const _token = ~action.data.token.indexOf('~') ? action.data.token.split('~')[1] : action.data.token
  newState.project = {
    id: action.data.id,
    token: action.data.token,
    name: action.data.name,
    starred: action.data.star
  }
  return Object.assign({}, state, newState)
}

function reduceActiveProjectConfig (state, action) {
  return {
    ...state,
    project: {
      ...state.project,
      config: action.data
    }
  }
}
